import React, { useState } from 'react';
import { X, Scroll, ImagePlus, VideoIcon, Save, Trash2 } from 'lucide-react';
import MultiImageUpload from './MultipleImage';
const Modal = ({ isOpen, onClose, onSubmit, formData, setFormData, title }) => {
    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 bg-black/75 backdrop-blur-sm flex items-center justify-center z-50 p-4">
            <div className="bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900 rounded-lg shadow-2xl w-full max-w-xl border border-amber-500/20 flex flex-col" style={{ maxHeight: 'calc(100vh - 2rem)' }}>
                {/* Header */}
                <div className="border-b border-amber-500/20 p-4 sticky top-0 bg-gray-900 z-10">
                    <div className="flex items-center justify-between">
                        <h2 className="text-xl font-bold bg-gradient-to-r from-amber-500 via-yellow-500 to-amber-500 bg-clip-text ">
                            {title}
                        </h2>
                        <button onClick={onClose} className="text-gray-400 hover:text-gray-200">
                            <X size={20} />
                        </button>
                    </div>
                </div>

                <div className="overflow-y-auto flex-1 p-4 custom-scrollbar">
                    <form onSubmit={(e) => {
                        e.preventDefault();
                        onSubmit(e);
                    }} className="space-y-4">
                        <div>
                            <label className="text-amber-500 font-medium mb-1 block">Title</label>
                            <input
                                type="text"
                                value={formData.title}
                                onChange={(e) => setFormData({ ...formData, title: e.target.value })}
                                className="w-full bg-gray-800/50 text-gray-100 rounded-lg p-2.5"
                                
                            />
                        </div>

                        <div>
                            <label className="text-amber-500 font-medium mb-1 block">Description</label>
                            <textarea
                                value={formData.description}
                                onChange={(e) => setFormData({ ...formData, description: e.target.value })}
                                className="w-full bg-gray-800/50 text-gray-100 rounded-lg p-2.5 h-24"
                            />
                        </div>

                        {/* <div>
                            <label className="text-amber-500 font-medium mb-1 block">Sacred Image</label>
                            {formData.image_url && (
                                <div className="mb-2 flex items-center justify-between bg-gray-800/30 p-2 rounded">
                                    <img
                                        src={formData.image_url}
                                        alt="Current"
                                        className="h-16 w-16 object-cover rounded"
                                    />
                                    <button
                                        type="button"
                                        onClick={() => setFormData({ ...formData, image_url: '' })}
                                        className="text-red-500 hover:text-red-400 p-1"
                                    >
                                        <Trash2 size={16} />
                                    </button>
                                </div>
                            )}
                            <input
                                type="file"
                                accept="image/*"
                                onChange={(e) => {
                                    const file = e.target.files?.[0];
                                    if (file) setFormData({ ...formData, image_file: file });
                                }}
                                className="w-full bg-gray-800/50 text-gray-100 rounded-lg p-2"
                            />
                        </div>

                        <div>
                            <label className="text-amber-500 font-medium mb-1 block">Mystical Video</label>
                            {formData.video_url && (
                                <div className="mb-2 flex items-center justify-between bg-gray-800/30 p-2 rounded">
                                    <video
                                        src={formData.video_url}
                                        className="h-16 w-32 object-cover rounded"
                                        controls
                                    />
                                    <button
                                        type="button"
                                        onClick={() => setFormData({ ...formData, video_url: '' })}
                                        className="text-red-500 hover:text-red-400 p-1"
                                    >
                                        <Trash2 size={16} />
                                    </button>
                                </div>
                            )}
                            <input
                                type="file"
                                accept="video/*"
                                onChange={(e) => {
                                    const file = e.target.files?.[0];
                                    if (file) setFormData({ ...formData, video_file: file });
                                }}
                                className="w-full bg-gray-800/50 text-gray-100 rounded-lg p-2"
                            />
                        </div> */}

                        <div className="space-y-6">
                            {/* Single Image Upload */}
                            <div>
                                <label className="text-amber-500 font-medium mb-1 block">Single Image</label>
                                <div className="space-y-2">
                                    {formData.image_url && (
                                        <div className="relative group">
                                            <img
                                                src={formData.image_url}
                                                alt="Preview"
                                                className="w-full h-32 object-cover rounded-lg"
                                            />
                                            <button
                                                type="button"
                                                onClick={() => setFormData({ ...formData, image_url: '', image_file: null })}
                                                className="absolute top-2 right-2 p-1 bg-red-500 rounded-full opacity-0 group-hover:opacity-100 transition-opacity"
                                            >
                                                <X size={16} className="text-white" />
                                            </button>
                                        </div>
                                    )}
                                    <input
                                        type="file"
                                        name="image_file"
                                        accept="image/*"
                                        onChange={(e) => {
                                            const file = e.target.files?.[0];
                                            if (file) {
                                                setFormData({
                                                    ...formData,
                                                    image_file: file,
                                                    image_url: URL.createObjectURL(file)
                                                });
                                            }
                                        }}
                                        className="w-full bg-gray-800/50 text-gray-100 rounded-lg p-2.5"
                                    />
                                </div>
                            </div>

                            {/* Slider Images */}
                            <div>
                                <label className="text-amber-500 font-medium mb-1 block">Slider Images</label>
                                <MultiImageUpload
                                    images={formData.slider_images || []}
                                    onChange={(images) => setFormData({ ...formData, slider_images: images })}
                                />
                            </div>

                            {/* Video Upload */}
                            <div>
                                <label className="text-amber-500 font-medium mb-1 block">Video</label>
                                <div className="space-y-2">
                                    {formData.video_url && (
                                        <div className="relative group">
                                            <video
                                                src={formData.video_url}
                                                className="w-full h-32 object-cover rounded-lg"
                                                controls
                                            />
                                            <button
                                                type="button"
                                                onClick={() => setFormData({ ...formData, video_url: '', video_file: null })}
                                                className="absolute top-2 right-2 p-1 bg-red-500 rounded-full opacity-0 group-hover:opacity-100 transition-opacity"
                                            >
                                                <X size={16} className="text-white" />
                                            </button>
                                        </div>
                                    )}
                                    <input
                                        type="file"
                                        name="video_file"
                                        accept="video/*"
                                        onChange={(e) => {
                                            const file = e.target.files?.[0];
                                            if (file) {
                                                setFormData({
                                                    ...formData,
                                                    video_file: file,
                                                    video_url: URL.createObjectURL(file)
                                                });
                                            }
                                        }}
                                        className="w-full bg-gray-800/50 text-gray-100 rounded-lg p-2.5"
                                    />
                                </div>
                            </div>
                        </div>

                        <div className="border-t border-amber-500/20 p-4 bg-gray-900/95 sticky bottom-0">
                            <div className="flex justify-end gap-3">
                                <button type="button" onClick={onClose} className="px-4 py-2 border border-amber-500/20 rounded-lg text-amber-500 hover:bg-amber-500/10">
                                    Cancel
                                </button>
                                <button type="submit" className="px-4 py-2 bg-gradient-to-r from-amber-500 to-yellow-500 text-gray-900 rounded-lg hover:from-amber-600 hover:to-yellow-600 font-medium">
                                    Save Changes
                                </button>
                            </div>
                        </div>
                    </form>
                </div>


            </div>
            <style jsx global>{`
       .custom-scrollbar::-webkit-scrollbar {
           width: 8px;
       }
       .custom-scrollbar::-webkit-scrollbar-track {
           background: rgba(251, 191, 36, 0.1);
           border-radius: 4px;
       }
       .custom-scrollbar::-webkit-scrollbar-thumb {
           background: rgba(251, 191, 36, 0.2);
           border-radius: 4px;
       }
       .custom-scrollbar::-webkit-scrollbar-thumb:hover {
           background: rgba(251, 191, 36, 0.3);
       }
   `}</style>
        </div>
    );
};

export default Modal;
